import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { InsightObjectViewLinkedObjectsSkeleton } from '@atlassian/jira-skeletons/src/ui/insight-object/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { LinkedObjectsPanelProps } from './ui/types.tsx';

const LazyLinkedObjectsPanel = lazyForPaint(
	() => import(/* webpackChunkName: "insight-linked-objects-panel" */ './ui'),
);

export const AsyncLinkedObjectsPanel = (props: LinkedObjectsPanelProps) => (
	<Placeholder
		name="insight-linked-objects-panel"
		fallback={<InsightObjectViewLinkedObjectsSkeleton />}
	>
		<LazyLinkedObjectsPanel {...props} />
	</Placeholder>
);
